export const ACCESS_TOKEN = "accessToken";
export const GOOGLE_AUTH_URL =
  process.env.REACT_APP_BASE_URL +
  "/oauth2/authorize/google?redirect_uri=" +
  process.env.REACT_APP_OAUTH2_REDIRECT_URI;
export const FACEBOOK_AUTH_URL =
  process.env.REACT_APP_BASE_URL +
  "/oauth2/authorize/facebook?redirect_uri=" +
  process.env.REACT_APP_OAUTH2_REDIRECT_URI;
export const GITHUB_AUTH_URL =
  process.env.REACT_APP_BASE_URL +
  "/oauth2/authorize/github?redirect_uri=" +
  process.env.REACT_APP_OAUTH2_REDIRECT_URI;
export const TWITTER_AUTH_URL =
  process.env.REACT_APP_BASE_URL +
  "/oauth2/authorize/twitter?redirect_uri=" +
  process.env.REACT_APP_OAUTH2_REDIRECT_URI;
export const UNSPLASH_ACCESS_KEY =
  "E6EW477qCmmmXMmP1X7wBouVSZVGlkIub-x1fCs7ipo";
